import React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import CardDirectory from '../cards/cardDirectory/CardDirectory';
import CardContact from '../cards/cardContact/CardContact';
import { ITenant, IContact } from '../../pages/types';
import './Search.css';

interface ISearchProps {
    query: string;
    contacts: IContact[];
    tenants: ITenant[];
    click: React.Dispatch<React.SetStateAction<any>>;
}

const Search: React.FC<ISearchProps> = (props) => {
    const searchQuery = props.query?.toLocaleLowerCase();

    const contacts = props.contacts.filter((item) => {
        return (
            item?.positionEnglish?.toLocaleLowerCase().includes(searchQuery) ||
            item?.positionFrench?.toLocaleLowerCase().includes(searchQuery) ||
            item?.emailEnglish?.toLocaleLowerCase().includes(searchQuery) ||
            item?.emailFrench?.toLocaleLowerCase().includes(searchQuery) ||
            item?.phoneEnglish?.toLocaleLowerCase().includes(searchQuery) ||
            item?.phoneFrench?.toLocaleLowerCase().includes(searchQuery)
        );
    });

    const tenants = props.tenants.filter((item) => {
        return item.suites?.toLocaleLowerCase().includes(searchQuery) || item.title?.toLocaleLowerCase().includes(searchQuery);
    });

    return (
        <div className="SearchOuter ">
            <ScrollContainer className="SearchInner TouchScroll" horizontal={false} vertical={true}>
                {tenants.map((element) =>
                    tenants.length > 0 ? (
                        <CardDirectory index={element.id} key={element.id} id={element.id} title={element.title} floor={element.suites} suite={element.id} category={element.categoryId} />
                    ) : (
                        <></>
                    )
                )}
                {contacts.map((element) =>
                    contacts.length > 0 ? (
                        <CardContact
                            id={element.id}
                            name={element.name}
                            userId={element.userId}
                            positionEnglish={element.positionEnglish}
                            positionFrench={element.positionFrench}
                            phoneFrench={element.phoneFrench}
                            phoneEnglish={element.phoneEnglish}
                            emailFrench={element.emailFrench}
                            emailEnglish={element.emailEnglish}
                            key={element.id}
                        />
                    ) : (
                        <></>
                    )
                )}
            </ScrollContainer>
        </div>
    );
};

export default Search;
